import Choice from './Choice';
import FieldDataType from './FieldDataType';
import FieldType from './FieldType';
import UnitType from './UnitType';

interface Field {
  label: string;
  uuid: string;
  key: string;
  data_type: FieldDataType;
  input_type: FieldType;
  default_value: string[];
  preview_default_value: string[]; // used only for Preview mode, single select and multiselect only
  sequence_index: number;
  subsequence_index: number;
  is_required: boolean;
  choices_json: Choice[];
  parent_uuid: string | null;
  parent_choice_uuid: string | null;
  measurement_unit?: UnitType | null;
}

const getNestedFieldsByChoice = (parentField: Field, fields: Field[]): { [key: string]: Field } => {
  const initialMapping: { [key: string]: Field } = {};

  return fields.reduce((mapping, field) => {
    if (field.parent_uuid === parentField.uuid) {
      if (field.parent_choice_uuid) {
        mapping[field.parent_choice_uuid] = field;
      }
    }

    return mapping;
  }, initialMapping);
};

export { getNestedFieldsByChoice };

export default Field;
